export default __webpack_public_path__ + "static/media/ic-register.47785829.svg";